/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useQuiz } from "src/contexts/QuizContext.js";
import { quizInteractionTracking } from "src/modules/QuizHelpers/index.js";

function QuizQuestionBoolean({ questionKey, sectionKey, question, dispatch }) {
  const section = question.subquestions[sectionKey];
  const allOptions = [...section.options];
  const { windowWidth } = useQuiz();

  useEffect(() => {
    const handler = () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    };
    document.addEventListener("mouseup", handler);
    return () => document.removeEventListener("mouseup", handler);
  }, []);

  const renderOptions = allOptions.map((option, optionIndex) => {
    return (
      <li key={option}>
        <button
          className={`quiz-question__options-button ${option === section?.currentAnswer ? "selected" : ""}`}
          value={option}
          onClick={(e) => {
            e.preventDefault();
            // Comprehensive focus reset for mobile devices
            e.target.blur();
            if (document.activeElement && document.activeElement.blur) {
              document.activeElement.blur();
            }
            document.body.focus();
            document.body.blur();

            // Get question number from questionKey (e.g., "question1" -> "Q1")
            const questionNumber = questionKey.replace("question", "Q");

            // Get sub question index from sectionKey (e.g., "section1" -> 1)
            const subQuestionIndex = sectionKey.replace("section", "");
            const subQuestionIndexNum = parseInt(subQuestionIndex, 10) || null;

            // Get selected answer index (1-based)
            const selectedAnswerIndex = optionIndex + 1;

            // Check if answer changed (had a previous answer)
            // Use savedAnswer first (persisted), then currentAnswer (temporary)
            // Only true if there was a previous answer AND it's different from current selection
            const previousAnswer = section.savedAnswer || section.currentAnswer;
            const answerChanged = previousAnswer ? previousAnswer !== option : false;

            // Determine if this is a sub-question (multiple sections) or main question
            const isSubQuestion = Object.keys(question.subquestions).length > 1;

            // Track option selection (same as QuizQuestionOptions)
            quizInteractionTracking({
              interaction_type: "select",
              question_number: questionNumber,
              sub_question_index: isSubQuestion ? subQuestionIndexNum : null,
              selected_answer_index: selectedAnswerIndex,
              answer_changed: answerChanged,
              navigation_action: null,
            });
            
            const type = windowWidth < 1024 ? "saveAnswer" : "currentAnswer";
            const delay = windowWidth < 1024 ? 500 : 0;
            setTimeout(() => {
              dispatch({
                type,
                payload: {
                  questionKey: questionKey,
                  sectionKey: sectionKey,
                  value: option,
                },
              });
              if (delay)
                dispatch({
                  type: "qContainerScroll",
                });
            }, delay);
          }}
        >
          {option}
        </button>
      </li>
    );
  });

  return (
    <>
      <div className="quiz-question__options options--boolean">
        <ul className="quiz-question__options-list">{renderOptions}</ul>
      </div>
    </>
  );
}

export default QuizQuestionBoolean;
